import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Reveal from 'react-reveal/Reveal';
import {styles} from '../common/animation';

class Contact  extends Component {

    render() {
        return ( 
            <div className="screen">
                <Reveal effect={css(styles.fadeIn)} duration={1500}>
                    <p className="contact_description">Je suis actuellement disponible pour de nouvelles opportunités.</p>
                    <h2 className="contact_intro"><span className="contact_intro-bold">Entrez en contact, </span> trouvez-moi en ligne à:</h2>
                    <div className="contact_icons">
                        <a href="https://www.linkedin.com/in/klaudia-b-98a15b107/" title="LinkedIn" target="_blank" rel="noopener noreferrer" className="contact-list-link">
                            <div className="contact-list-link-icon linkedIn" ></div> 
                        </a>
                        <a className="contact-list-link" target="_blank" rel="noopener noreferrer" title="Gitlab" href="https://gitlab.com/Klaudia2017">
                            <div className="contact-list-link-icon gitlab" ></div>
                        </a>
                        <a href="mailto:brysiewiczk@gmail.com" title="Gmail" target="_blank" rel="noopener noreferrer" className="contact-list-link">
                            <div className="contact-list-link-icon mail" ></div>
                        </a>
                    </div> 
                </Reveal>
            </div>
        );
    }
}

export default Contact;
  


// WEBPACK FOOTER //
// ./src/components/containers/Contact.js